import { render, staticRenderFns } from "./UserActiveToggle.vue?vue&type=template&id=56588fc3&"
import script from "./UserActiveToggle.vue?vue&type=script&lang=js&"
export * from "./UserActiveToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports